import Vue from 'vue'
import Vuex from 'vuex'
import data from './data'
import _ from 'lodash'

import {common} from './modules'
let userInfo = {
  token: '',
  headImage: '',
  serverId: '',
  nickname: '',
  username: ''
}
if (sessionStorage.getItem('userInfo')) {
  userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
}
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    code: '',
    symbol: '',
    market: '',
    region: '', // HK, USA, CN
    isIndex: false,
    indexs: {
      '399005': 'sz',
      '399001': 'sz',
      '399006': 'sz',
      '000001': 'sh',
      '000016': 'sh',
      '000300': 'sh',
      '.HSI': 'HKIDX',
      '.HSCC': 'HKIDX',
      '.HSCE': 'HKIDX',
      'DIA': 'AMEX',
      'SPY': 'AMEX',
      'QQQ': 'NASDAQ',
    },
    status: -1,
    dyna: {},
    statistic: {},
    profile: {},
    tick: [],
    statics: {},
    stockname: '',
    homeScrollTop: 0,
    userInfo,
    hsList: [] // 沪深指数
  },
  mutations: {
    setHomeScrollTop(state, val) {
      state.homeScrollTop = val
    },
    setSymbol(state, {code, market}) {
      console.log('======setSymbol', code, market)
      store.commit('setRegion', market)
      code = code.toLocaleUpperCase()
      state.symbol = code
      code = state.region === 'HK' && code[0] !== '.' ? code.substring(1) : code
      if(state.code !== code) {
        state.common.tabs.map(tab => {
          tab.pageNo = 0
          tab.list = []
          return tab
        })
      }
      state.code = code
      state.market = market
      store.commit('setRegion', market)
      if (state.indexs[code] && state.indexs[code].toLowerCase() === market.toLowerCase()) {
        state.isIndex = true
        state.common.tabs = [
          {
            label: '资讯',
            list: [],
            pageNo: 0,
            pageSize: 20,
            key: 'zixun'
          },
          // {
          //   label: '股圈',
          //   key: 'guba',
          //   list: [],
          //   pageNo: 0,
          // },
          // {
          //   label: '九方速递',
          //   key: 'focus',
          //   list: [],
          // }
        ]
      } else if(~market.toLowerCase().indexOf('etf')){
        state.common.tabs = [
          {
            label: '资讯',
            list: [],
            pageNo: 0,
            pageSize: 20,
            key: 'zixun'
          },
          {
            label: '公告',
            list: [],
            pageNo: 0,
            pageSize: 20,
            key: 'gonggao'
          }
        ]
      } else {
        state.isIndex = false
        state.common.tabs = [
          {
            label: '资讯',
            list: [],
            pageNo: 0,
            pageSize: 20,
            key: 'zixun'
          },
          {
            label: '公告',
            list: [],
            pageNo: 0,
            pageSize: 20,
            key: 'gonggao'
          },
          {
            label: '研报',
            list: [],
            pageNo: 0,
            pageSize: 20,
            key: 'yanbao'
          },
          {
            label: '简况',
            list: [],
            pageNo: 0,
            key: 'jiankuang'
          },
          {
            label: '财务',
            key: 'caiwu'
          },
          // {
          //   label: '股圈',
          //   key: 'guba',
          //   list: [],
          //   pageNo: 0,
          // },
          {
            label: '板块',
            key: 'bankuai',
            list: [],
          },
          // {
          //   label: '九方速递',
          //   key: 'focus',
          //   list: [],
          // }
        ]
      }
      store.commit('setRegion', market)
      let type = state.isIndex ? 202 : 201
      data.subscribe(code, market, state.region,type)
    },
    setRegion (state, market) {
      market = market.toLocaleUpperCase()
      switch(market) {
        
        case 'HK':
        case 'HKSE':
        case 'HKIDX':
          state.region = 'HK'
          break
        case 'NYSE':
        case 'NASDAQ':
        case 'AMEX':
          state.region = 'USA'
          break
        default:
          state.region = 'CN'
      }
    },
    setStockName(state, name) {
      state.stockname = name
      window.document.title = name || '九方智投'
    },
    setStatus (state, type) {
      if(state.status !== type && state.status !== -1) {
        setTimeout(() => {
          window.location.reload()
        }, 60000)
      }
      state.status = type
    },
    setStatistics (state, obj) {
      state.statistic = obj
    },
    setDyna (state, obj) {
      state.dyna = obj
    },
    setTick (state, arr) {
      state.tick.push(...arr)
    },
    setProfile(state, obj) {
      // console.error(obj)
      state.profile = obj
    },
    setStatic(state, obj) {
      state.statics = obj
    },
    setUserInfo(state, obj) {
      state.userInfo = obj
      sessionStorage.setItem('userInfo', JSON.stringify(obj))
    },
    setHsList(state, list) {
      state.hsList = list
    },
  },
  modules: {
    common,
  }
})

export default store
